/**
 * Monday API 2025-10+ returns status labels as an array of objects on `settings`.
 * Older API versions used a string map on `settings_str` (`{ "0": "Done" }`).
 */
const normalizeStatusLabels = (labels) => {
  if (!labels) {
    return [];
  }

  if (Array.isArray(labels)) {
    return labels
      .filter((item) => item && typeof item === 'object' && !item.is_deactivated)
      .map((item) => {
        const text = typeof item.label === 'string' ? item.label : '';
        return { value: text, label: text };
      })
      .filter((option) => option.label);
  }

  if (typeof labels === 'object') {
    return Object.values(labels)
      .filter((value) => typeof value === 'string' && value)
      .map((text) => ({ value: text, label: text }));
  }

  return [];
};

const resolveColumnSettings = (columnMeta) => {
  if (columnMeta?.settings && typeof columnMeta.settings === 'object') {
    return columnMeta.settings;
  }

  try {
    return JSON.parse(columnMeta?.settings_str || '{}');
  } catch {
    return {};
  }
};

/**
 * Resolve dropdown options from a Monday status column.
 * Accepts either `column_values` (nested `column.settings`) or `board.columns`
 * (flat `settings` / `settings_str`).
 */
export const getDropdownLabels = ({ boardColumns, targetColumnId }) => {
  if (!boardColumns?.length || !targetColumnId) {
    return [];
  }

  const columnObject = boardColumns.find((col) => col.id === targetColumnId);
  if (!columnObject) {
    return [];
  }

  const columnMeta = columnObject.column ?? columnObject;
  const settings = resolveColumnSettings(columnMeta);

  return normalizeStatusLabels(settings?.labels);
};
